import { render, staticRenderFns } from "./DownloadAccountEdit.vue?vue&type=template&id=5aa66a0d"
import script from "./DownloadAccountEdit.vue?vue&type=script&lang=js"
export * from "./DownloadAccountEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports